const initialState = {
  actionProcessing: false,
  history: [],
  pageCount: 1,
};

export default initialState;
